// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const AiApplicationDiscoveryStatusSchema = z.enum(['PENDING','RUNNING','COMPLETE','FAILED'] as const);

export type AiApplicationDiscoveryStatusType = `${z.infer<typeof AiApplicationDiscoveryStatusSchema>}`

export default AiApplicationDiscoveryStatusSchema;
